module.exports = __webpack_public_path__ + "img/how-v2.18713f54.webp";